module.exports = __webpack_public_path__ + "img/sql.6c60749.svg";